import { Suspense, useMemo } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import useAuth from "./hooks/useAuth";
import Loader from "./components/Loader";
import { protectedRoutes, unprotected } from "./config/routes";
import Layout from "./components/Layout/Layout";


function App() {
  const { accessToken } = useAuth();

  const appRoutes = useMemo(
    () =>
      protectedRoutes.map((route) => {
        return route?.component ? (
          <Route
            key={route?.id}
            path={route?.path}
            element={
              !!accessToken ? (
                route?.component
              ) : (
                <Navigate to="/login" replace />
              )
            }
          />
        ) : null;
      }),
    [accessToken]
  );

  const appUnprotected = unprotected.map((route) => {
    return route?.component ? (
      <Route key={route?.id} path={route?.path} element={route?.component} />
    ) : null;
  });

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        {appUnprotected}
        <Route path="/" element={<Layout />}>
          {appRoutes}
        </Route>
      </Routes>
    </Suspense>
  );
}

export default App;
